import "./LoadingOverlay.css"

const LoadingOverlay = () => {
  return (
    <div className="loading-overlay">
      <div className="spinner" />
      <p className="loading-text"></p>
    </div>
  );
};

export default LoadingOverlay;
